export default () => ({
    supportedCharacters: []
});
